import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { Card, Button, Table, Form, Col, Row, Popover, OverlayTrigger, FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useRef, useState } from "react";
import { addOrUpdateUser, getUserRoleList, searchUser, selectPageNode, grantOrRemovePermission, GrantFullPermission, deleteUser, findPagePath, copyUserPermission, getUserList4Modal, getUserMenuList, updateUserMenuAccessNumber } from "../store/api/Users";
import {
    CheckLg, PencilFill, CaretRightFill, CaretLeftFill, DashCircle, PlusSquare, Trash, LockFill, List, PersonLinesFill, Tools,
    CalculatorFill, EnvelopeOpenFill, DisplayFill, GearWideConnected, ArrowLeftSquare, CheckAll, Search, FileEarmarkPost,
    Files,
    CloudArrowUp,
    CloudArrowDown,
    HouseGear,
    HouseGearFill,
    GeoAlt,
    ListColumns,
    PencilSquare
} from "react-bootstrap-icons";
import { setDialog } from "../store/api/GetAllProduct";
import { attachFile, downloadFile, setErrorDialog } from "../../store/api/CommonFunctions";
import TreeViewItem from "../../Components/TreeViewItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faListAlt, faTimesCircle, faUserPlus, faUsersCog } from "@fortawesome/free-solid-svg-icons";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { enforceMinMax } from "../../store/api/CommonFunctions";
import ModalMap from "../../Components/Modals/ModalMap";
import BihamtaTable from "../../Components/BihamtaTable";

const UserManagement = () => {
    const currPage = useRef(1);
    const inputFile = useRef();
    const totalPage = useRef(0);
    let currentRole = useRef([]);
    const searchData = useRef({});
    const dispatch = useDispatch();
    const changedItems = useRef([]);
    const permissionUserID = useRef();
    const inputSearchPermission = useRef();
    const inputSourceUserForCopy = useRef();
    const [userInfo, setUserInfo] = useState(null);
    const [showInfo, setShowInfo] = useState(false);
    const [isPending, setPending] = useState(false);
    const [pendingMenu, setPendingMenu] = useState(false);
    const [selectingUserList, setSelectingUserList] = useState([]);
    const { register, handleSubmit, errors } = useForm();
    const [showPermission, setShowPermission] = useState(false);
    const [foundPermissions, setFoundPermissions] = useState([]);
    const [mapData, setMapData] = useState({ show: false });
    const [menuList, setMenuList] = useState();
    const selectedMenues = useRef([]);
    const tempMenuList = useRef();
    if (menuList?.Data?.length > 100) {
        tempMenuList.current = [...menuList.Data];
    }
    const { roleList, userList } = useSelector(state => {
        return {
            roleList: state.UserReducer.userRoleList,
            userList: state.UserReducer.userList
        }
    });
    if (totalPage.current < 1) {
        const t = userList && userList.TotalCount ? Number(userList.TotalCount) : 0;
        totalPage.current = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }
    const menuTableCols = [
        //منو که تیک بخورد زیر سیتم هم تیک می خورد پس نیازی به این ستون نیست.
        // { colTitle: "", colName: "SubSystemChecked", colType: "boolean", editable: true, onChange: (row) => console.log(row.e.target.checked) },
        { colTitle: "", colName: "MenuChecked", colType: "boolean", editable: true, selectAll: selectAllRows, onChange: checkMenu },
        { colTitle: "زیرسیستم", colName: "SubsystemTitle" },
        { colTitle: "منو", colName: "MenuTitle" },
        { colTitle: "", colName: "MenuCode", style: { display: "none" }, headerStyle: { display: "none" } },
        { colTitle: "", colName: "SubsystemCode", style: { display: "none" }, headerStyle: { display: "none" } }
    ]
    const popSelectUser = (
        <Popover style={{ fontFamily: "Vazir", minWidth: "200px" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faFileExport} size="lg" />&nbsp;
                کپی دسترسی
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                {Array.isArray(selectingUserList) &&
                    <FormGroup>
                        <select className="form-control" ref={inputSourceUserForCopy}>
                            <option value="">انتخاب کنید</option>
                            {selectingUserList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                        </select>
                    </FormGroup>
                }
                <Button className="group-Btn mt-2" onClick={copyPermission}><Files size={18} />کپی دسترسی</Button>
            </Popover.Content>
        </Popover>
    )
    const popMenuAccess = (
        <Popover style={{ fontFamily: "Vazir", minWidth: "450px" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faListAlt} size="lg" />&nbsp;
                منو
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <FormGroup className="mt-0">
                    <label>زیرسیستم ها:</label>
                    <select className="form-control mb-1" onChange={e => filterMenu(e.target.value)}>
                        <option value="">تمام زیر سیستم ها</option>
                        <option value={2}>اطلاعات پایه</option>
                        <option value={4}>اتوماسیون اداری</option>
                        <option value={8}>حسابداری</option>
                        <option value={16}>فروش</option>
                        <option value={32}>تولید</option>
                        <option value={64}>خدمات پس از فروش</option>
                        <option value={128}>مشتریان</option>
                        <option value={256}>دستور کار</option>
                        <option value={512}>پیامک ها</option>
                        <option value={1024}>یادآوری ها</option>
                        <option value={2048}>مدیریت سیستم</option>
                    </select>
                </FormGroup>
                <BihamtaTable dataList={menuList} maxHeight={350} columns={menuTableCols} searchable />
                <Button className="group-Btn mt-1" variant="info" onClick={submitMenuAccess}><PencilSquare size={18} />&nbsp;ویرایش دسترسی منو</Button>
            </Popover.Content>
        </Popover>
    )
    function filterMenu(subsysCode) {
        if (subsysCode === "") {
            getUserMenuList(userInfo.ID, setMenuList);
        }
        else {
            const filtered = tempMenuList.current.filter(m => Number(m.SubsystemCode) === Number(subsysCode));
            setMenuList({ Data: filtered });
        }
    }
    function checkMenu(menu) {
        if (menu.e.target.checked) {
            const exists = selectedMenues.current.some(m => Number(m.Item1) === Number(menu.SubsystemCode) && Number(menu.MenuCode) === Number(m.Item2));
            if (!exists) {
                selectedMenues.current.push({ Item1: menu.SubsystemCode, Item2: menu.MenuCode });
            }
        }
        else {
            selectedMenues.current = selectedMenues.current.filter(m => Number(m.Item1) !== Number(menu.SubsystemCode) || Number(menu.MenuCode) !== Number(m.Item2));
        }
    }
    function initMenuList() {
        if ((menuList?.Data?.length > 100 && Number(menuList.Data[0].UserID) === Number(userInfo.ID)) || !userInfo?.ID) {
            return;
        }
        const onGet = (res) => {
            setMenuList(res);
            if (res.Data) {
                for (var indx in res.Data) {
                    const m = res.Data[indx];
                    if (m.MenuChecked) {
                        selectedMenues.current.push({ Item1: m.SubsystemCode, Item2: m.MenuCode });
                    }
                }
            }
        }
        getUserMenuList(userInfo.ID, onGet);
    }
    function selectAllRows(e) {

        selectedMenues.current = [];
        menuList.Data.forEach(m => {
            m.MenuChecked = e.target.checked;
            m.SubSystemChecked = e.target.checked;
            if (m.MenuChecked) {
                selectedMenues.current.push({ Item1: m.SubsystemCode, Item2: m.MenuCode })
            }
        });
        const tmp = { ...menuList };
        setMenuList("PENDING");
        setTimeout(() => setMenuList(tmp), 5);
    }
    function submitMenuAccess() {
        setPendingMenu(true);
        const onUpdate = (res) => {
            setPendingMenu(false);
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "بروزرسانی دسترسی منو");
                return;
            }
            else if (res.Data) {
                selectedMenues.current = [];
                setMenuList(null);
                setUserInfo(null);
                setShowInfo(false);
                setErrorDialog(dispatch, "success", "بروزرسانی دسترسی منو");
                return;
            }

        }
        updateUserMenuAccessNumber(userInfo.ID, selectedMenues.current, onUpdate);
    }
    const search = (reset, e) => {
        if (e?.key && e.key !== "Enter") {
            return;
        }
        if (reset) {
            totalPage.current = 0;
            currPage.current = 1;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 10;
        dispatch(searchUser(searchData.current));
    }
    function copyPermission() {
        const selected = inputSourceUserForCopy.current.value;
        if (!(Number(selected) > 0)) {
            setErrorDialog(dispatch, "کاربری انتخاب نشده است", "کپی دسترسی");
            return;
        }
        const onCopyDone = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "کپی دسترسی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "کپی دسترسی");
            }

        }
        copyUserPermission(selected, userInfo.ID, onCopyDone);
    }
    const goToEditMode = (user) => {
        if (user.RoleList && user.RoleList !== "") {
            currentRole.current = user.RoleList.replace(/,,/g, ",").split(",");//.map(Number);
        }
        setUserInfo(user);
        setShowInfo(true);
    }
    const goToInsertMode = () => {
        setShowInfo(true);
    }
    const cancelUser = () => {
        currentRole.current = [];
        setUserInfo({});
        setShowInfo(false);
    }
    const cancelPermission = () => {
        changedItems.current = [];
        setShowPermission(false);
        setFoundPermissions([]);
    }
    const addRemoveRole = (item) => {
        if (!currentRole.current) {
            currentRole.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!currentRole.current.includes(splited)) {

                currentRole.current.push(...splited);
            }
        }
        else {
            currentRole.current = currentRole.current.filter(a => !splited.includes(a));
        }
        // if (add) {
        //     if (!currentRole.current.includes(id))
        //         currentRole.current.push(id);
        // }
        // else {
        //     currentRole.current = currentRole.current.filter(r => r !== id);
        // }
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        search();
    }
    const onSubmit = (data) => {
        if (data.Password !== data.DupPassword) {
            setErrorDialog(dispatch, "گذرواژه و تکرار آن باید همسان باشد", "ثبت اطلاعات");
            return;
        }
        if (Array.isArray(data.IsActive) && data.IsActive.includes('on')) {
            data.IsActive = true;
        }
        if (userInfo) {
            data.ID = userInfo.ID;
        }
        if (currentRole.current && currentRole.current.length > 0) {
            data.RoleList = currentRole.current.filter(r => r !== 0).join(",");
            data.RoleList = "," + data.RoleList.replace(/,/g, ",,") + ",";
        }
        const onSuccess = (res) => {
            setPending(false);
            if (res.Result) {
                search(true);
                currentRole.current = [];
                setUserInfo({});
                setShowInfo(false);
            }
            else {
                setErrorDialog(dispatch, res.Message, "ثبت/ویرایش اطلاعات کاربر");
            }
        }
        setPending(true);
        addOrUpdateUser(data, onSuccess);
    }
    const showPermissionList = (userID) => {
        permissionUserID.current = userID
        setShowPermission(true);
    }
    const nodeClick = (el) => {
        const elArray = document.querySelectorAll(".clickedNode");
        elArray.forEach(el => el.classList.remove("clickedNode"));
        el.classList.add('clickedNode');
    }
    const submitPermission = () => {
        if (changedItems.current.length === 0) {
            setShowPermission(false);
            return;
        }
        const onSuccess = () => {
            setShowPermission(false);
            changedItems.current = [];
        }
        dispatch(grantOrRemovePermission(changedItems.current, onSuccess));
    }
    const grantAll = () => {
        const onSuccess = () => {
            setShowPermission(false);
            changedItems.current = [];
        }
        dispatch(GrantFullPermission(permissionUserID.current, onSuccess));
    }
    function findPath(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        const name = inputSearchPermission.current.value;
        if (name === "") {
            setFoundPermissions([]);
            return;
        }
        findPagePath(name, setFoundPermissions);
    }
    function attachSignature() {
        const onAttach = () => {
            setUserInfo(null);
            setShowInfo(false);
            search();
        }
        dispatch(attachFile(inputFile.current, userInfo.ID, "UserAttachment", onAttach));
    }
    function showMap() {
        setMapData({ show: true, location: { lat: userInfo.Latitude, lng: userInfo.Longitude } });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اطلاعات پایه";
        dispatch(getUserRoleList());
        search();
        getUserList4Modal("", setSelectingUserList);
    }, []);
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">
                <FontAwesomeIcon icon={faUsersCog} size="lg" />&nbsp; مدیریت کاربران</Card.Header>
            <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                {showPermission && !showInfo &&
                    <Fragment>
                        <TreeViewItem hasPanel={true} changedItems={changedItems} userID={permissionUserID.current} title="دسترسی ها" displaySubItems={{ fn: selectPageNode, canDispatch: false }} items={[
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "تولیـد", name: "Production", icon: <HouseGearFill size={16} color="#f10052" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "مشتریان", id: 7, name: 'CRM', icon: <PersonLinesFill size={16} />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "امور مالی", name: "Finances", icon: <CalculatorFill size={16} color="#97055a" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "فروش و انبار", name: "SaleAndStorage", icon: <FileEarmarkPost size={16} color="#1098ac" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "اتوماسیون اداری", id: 3, name: 'OfficeAutomation', icon: <EnvelopeOpenFill size={15} color="#116592" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "خدمات پس از فروش", id: 6, name: 'AfterSalesService', icon: <Tools size={15} color="#d45006" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "مانیتورینگ و مدیریت", id: 9, name: 'Management', icon: <DisplayFill size={15} color="#9c399c" />
                            },
                            {
                                type: "link", to: "", onClick: (e) => { nodeClick(e.currentTarget) },
                                text: "تنظیمات و تعاریف عمومی", id: 1, name: 'GeneralSettings', icon: <GearWideConnected size={15} color="#0937ad" />
                            }
                        ]} />
                        <div className="rowBorder" style={{ padding: "8px" }}>
                            <Col md={4} className="mt-1 form-group">
                                <Form.Control ref={inputSearchPermission} placeholder="نام صفحه مورد جستجو" onKeyDown={findPath} />
                                <Button className="btn-input-tiny" style={{ top: "4px", left: "3px" }} onClick={findPath}><Search size={20} /></Button>
                            </Col>
                            <div style={{ padding: "5px" }}>
                                {foundPermissions?.Data && Array.isArray(foundPermissions.Data) &&
                                    foundPermissions.Data.map((item, i) => <div key={i}>{item}</div>)}
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button variant="success" className="group-Btn" onClick={submitPermission}><CheckLg />&nbsp;ثبت تغییرات</Button>
                            <Button className="group-Btn" onClick={grantAll}><CheckAll size={19} />&nbsp;دسترسی کامل</Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelPermission}><ArrowLeftSquare size={18} />&nbsp;بازگشت به لیست</Button>
                        </div>
                    </Fragment>
                }
                {showInfo && !showPermission &&
                    <>
                        <ModalMap location={mapData.location} show={mapData.show} setMapPop={setMapData} />
                        <form onSubmit={handleSubmit(onSubmit)} readOnly>
                            <div className="row rowBorder" style={{ paddingBottom: "10px", margin: 0 }}>
                                <div className="rowTitle">
                                    <FontAwesomeIcon icon={faTimesCircle} size="lg" color="red" onClick={cancelUser} />&nbsp;
                                    اطلاعات کاربر

                                </div>
                                <div className="form-group col-md-2">
                                    <label>نام کامل</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                    <input type="text" className="form-control" name="Name" defaultValue={userInfo?.Name??""} ref={register({ required: true })} />
                                    {errors.Name && <small className="errors">وارد کردن نام الزامی است</small>}
                                </div>
                                <div className="form-group col-md-2">
                                    <label>نام کاربری</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                    <input type="text" className="form-control" name="UserName" defaultValue={userInfo?.UserName??""} ref={register({ required: true })} />
                                    {errors.UserName && <small className="errors">وارد کردن نام کاربری الزامی است</small>}
                                </div>
                                <div className="form-group col-md-2">
                                    <label>گذرواژه</label>
                                    <input type="password" name="Password" className="form-control" defaultValue={userInfo?.Password??""} ref={register({ required: !userInfo || !userInfo.ID })} />
                                    {errors.Password && <small className="errors">وارد کردن گذرواژه الزامی است</small>}
                                </div>
                                <div className="form-group col-md-2">
                                    <label>تکرار گذرواژه</label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                                    <input type="password" name="DupPassword" className="form-control" defaultValue={userInfo?.Password??""} ref={register({ required: !userInfo || !userInfo.ID })} />
                                    {errors.DupPassword && <small className="errors">وارد کردن تکرار گذرواژه الزامی است</small>}
                                </div>
                                <div className="form-group col-md-2">
                                    <label>شماره داخلی</label>
                                    <input type="text" className="form-control" name="CRMLineNumber" defaultValue={userInfo?.CRMLineNumber??""} ref={register({})} />
                                </div>
                                <Col md={2} className="form-group">
                                    <label>صفحه اصلی</label>
                                    <Form.Control as="select" name='HomePage' defaultValue={userInfo?.HomePage ?? ""} ref={register({})}>
                                        <option value="">انتخاب کنید</option>
                                        <option value="Accounting">سیستم حسابداری</option>
                                        <option value="CRM">سیستم مشتریان</option>
                                        <option value="Office">سیستم اتوماسیون</option>
                                        <option value="Sale">سیستم فروش و انبار</option>
                                        <option value="Services">سیستم خدمات پس از فروش</option>
                                        <option value="AgentPanel">پنل نمایندگی</option>
                                    </Form.Control>
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>آغاز ساعت کار:</label>
                                    <Form.Control type="number" name="AllowedWorkingHourFrom" defaultValue={userInfo?.AllowedWorkingHourFrom ?? ""} ref={register({})} min={0} onKeyUp={enforceMinMax} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>پایان ساعت کار:</label>
                                    <Form.Control type="number" name="AllowedWorkingHourTo" defaultValue={userInfo?.AllowedWorkingHourTo ?? ""} ref={register({})} max={24} onKeyUp={enforceMinMax} />
                                </Col>
                                <div className="form-group col-md-2">
                                    <label>&nbsp;</label>
                                    <div className="mt-1" style={{ border: "1px solid gray", borderRadius: "3px", height: "35px", padding: "6px" }}>
                                        <input type="checkbox" name="IsActive" className="form-check-input" ref={register()} defaultChecked={userInfo && userInfo.IsActive !== undefined ? userInfo.IsActive : true} />
                                        &nbsp;
                                        <label style={{ color: "blue", marginTop: "2px" }}>فعال است</label>
                                    </div>
                                </div>
                                <div className="form-group col-md-2">
                                    <label>فهرست نقش ها</label>
                                    <BihamtaMultiSelect dataSource={roleList} valueItem="RoleID" displayItem="RoleName" onItemCheckChanged={addRemoveRole} defaultCheckedList={currentRole.current} />
                                </div>
                                {userInfo?.ID &&
                                    <Col md={2} className="form-group">
                                        <label>
                                            {userInfo?.SignatureFileName?.length > 0 ? 'تغییر امضا' : "بارگذاری امضا"}:
                                        </label>
                                        <input type="file" className="form-control" ref={inputFile} accept="image/*" />
                                        <Button className="btn-input-tiny" style={{ top: "25px" }} onClick={attachSignature}><CloudArrowUp size={23} /></Button>
                                    </Col>
                                }
                                <div>
                                    <Button type="submit" variant="success" style={{ float: "right" }} className="mt-2 group-Btn" disabled={isPending}> {isPending ? <Loader type="BallTriangle" color="white" height={20} width={20} style={{display:"inline-block"}}/> : <CheckLg size={17} />}&nbsp;ثبت اطلاعات</Button>
                                    <Button variant="danger" style={{ float: "right" }} className="mt-2 group-Btn" onClick={cancelUser}><DashCircle size={16} />&nbsp;انصراف</Button>
                                    {userInfo?.SignatureFileName?.length > 0 && <Button className="group-Btn mt-2" onClick={() => downloadFile(userInfo.ID, "UserAttachment", true)}><CloudArrowDown size={18} />&nbsp;نمایش فایل امضا</Button>}
                                    {Number(userInfo?.ID) > 0 &&
                                        <>
                                            <OverlayTrigger overlay={popSelectUser} trigger="click">
                                                <Button variant="info" className="mt-2 group-Btn"><Files size={18} />&nbsp;کپی دسترسی</Button>
                                            </OverlayTrigger>
                                            <Button variant="secondary" className="mt-2 group-Btn" onClick={showMap}><GeoAlt size={18} />&nbsp;آخرین موقعیت</Button>
                                            <OverlayTrigger overlay={popMenuAccess} trigger="click" placement="left" rootClose>
                                                <Button className="mt-2 group-Btn btn-violet" onClick={initMenuList}><ListColumns size={18} />&nbsp; دسترسی منو</Button>
                                            </OverlayTrigger>
                                        </>
                                    }
                                </div>
                            </div>
                        </form>
                    </>
                }
                {!showInfo && !showPermission &&
                    <Button className="group-Btn-smalll" variant="info" title="کاربر جدید" onClick={goToInsertMode}><FontAwesomeIcon icon={faUserPlus} size="2x" /></Button>
                }
                {!showInfo && !showPermission &&
                    <Row className="mt-0">
                        <Col md={2} className="form-group">
                            <input className="search-input" placeholder="نام/نام کاربری" defaultValue={searchData.current.NameOrUserName ?? ""}
                                onChange={e => searchData.current.NameOrUserName = e.target.value} onKeyDown={e => search(true, e)} />
                            <Button className="btn-input-tiny" style={{ top: 4 }} onClick={() => search(true)}><Search size={18} /></Button>
                        </Col>
                    </Row>
                }
                {!showPermission &&
                    <Fragment>
                        <Table className="mt-1">
                            <thead>
                                <tr>
                                    <th>نام و نام خانوادگی</th>
                                    <th>نام کاربری</th>
                                    <th>نقش ها</th>
                                    <th style={{ width: "50px" }}>فعال</th>
                                    <th style={{ width: "100px" }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    userList === "PENDING" &&
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center", width: "100%" }}>
                                            <Loader type="BallTriangle" width={30} height={30} color="#bb1370" />
                                        </td>
                                    </tr>
                                }
                                {userList?.Data && Array.isArray(userList.Data) &&
                                    userList.Data.map((item, i) =>
                                        <tr key={i} className="resultTableRow">
                                            <td>{item.Name}</td>
                                            <td>{item.UserName}</td>
                                            <td style={{ maxWidth: "300px" }}>{item.RoleNameList}</td>
                                            <td style={{ width: "50px" }}><input type="checkbox" className="form-check-input" readOnly checked={item.IsActive} /></td>
                                            <td style={{ width: "100px" }}>
                                                <PencilFill className="rowBtn" color="#da6e0d" size={16} onClick={() => goToEditMode(item)} />
                                                &nbsp;
                                                <Trash color="red" size={16} className="rowBtn" onClick={() => {
                                                    dispatch(setDialog({
                                                        status: 'show',
                                                        arrayBtn: ['yes', 'no'],
                                                        dialogTitle: 'حذف کاربر',
                                                        dialogText: 'آیا از حذف مطمئن هستید؟',
                                                        okOperation: deleteUser(item.ID, search)
                                                    }))
                                                }} />
                                                &nbsp;&nbsp;
                                                <span className="rowBtn" onClick={() => showPermissionList(item.ID)}>
                                                    <LockFill size={16} color="#910766" /><List className="scaleIcon" size={14} color="#910766" />
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <div style={{ textAlign: "center" }}>
                            <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                            <span>{currPage.current + " از " + totalPage.current}</span>{userList && userList.TotalCount && <span style={{ color: "gray" }}>&nbsp;({userList.TotalCount})</span>}
                            <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage.current} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                        </div>
                    </Fragment>
                }
            </Card.Body>
        </Card>
    </div >
    )
}
export default UserManagement;